<template>
<span class="nowrap">
    {{ timestamp_date | timestamp_rel }}<i v-if="!no_calendar" class="ion-calendar text-muted ml-2" v-popover="`${timestamp_date.toLocaleString()} (${get_utc_offset_string()})`"></i>
</span>
</template>
<script>
import { Utils } from '@/helpers/utils';

export default {
    props: {
        timestamp: [Date, Number],
        no_calendar: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        timestamp_date(){
            // If a number is given, convert it to a Date
            return typeof this.timestamp == 'number' 
                    ? new Date(this.timestamp*1000) 
                    : this.timestamp
        }
    },
    methods: {
        get_utc_offset_string(){return Utils.get_utc_offset_string()}
    },
   
}
</script>
